




















































































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Hamburger from '@/components/Hamburger/index.vue'
import { logout } from '@/api/users'
import { removeCookie } from '@/utils/cookies'

@Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    Hamburger
  }
})
export default class extends Vue {
  avatar = ''
  userName = ''
  token = ''
  created() {
    this.getUserInfo()
  }
  getUserInfo() {
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      let obj = JSON.parse(userInfo)
      const { image: avatar, userName, token } = obj
      this.avatar = avatar
      this.userName = userName
      this.token = token
    }
  }
  toggleSideBar() {
    console.log('switch')
    AppModule.ToggleSideBar(false)
  }

  private async logout() {
    let res: any = await logout({ token: this.token })
    if (res.status.code === 0) {
      // 退出成功, 清空相应信息
      removeCookie('token')
      localStorage.removeItem('userInfo')
      this['$router'].push(`/login?redirect=${this.$route.fullPath}`)
    } else {
      this['$message'].error('登出失败!')
    }
  }
  get sidebar() {
    return AppModule.sidebar
  }
}
